import { render, staticRenderFns } from "./PersonSelectorCard.vue?vue&type=template&id=0e9ffd42&scoped=true&"
import script from "./PersonSelectorCard.vue?vue&type=script&lang=js&"
export * from "./PersonSelectorCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonSelectorCard.vue?vue&type=style&index=0&id=0e9ffd42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ffd42",
  null
  
)

export default component.exports